import React, { useState, useEffect } from "react";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import DashboardCards from "../Components/DashboardCards";
import DashboardTaskTabs from "../Components/DashboardTaskTabs";
import OverlayLoader from "../Components/OverlayLoader";
import FollowupTypeLead from "../Components/FollowupTypeLead";
import { useNavigate, useLocation } from "react-router-dom";

const Dashboard: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // Adjust time based on your components' typical load time

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const getMenus = async () => {
      setIsLoading(true);
      try {
        const menuID = location.state?.menuID;
        const previousMenuID = localStorage.getItem("activeMenuID");
        if (menuID !== previousMenuID || menuID === null) {
          localStorage.setItem("activeMenuID", menuID);
        } else {
          localStorage.removeItem("activeMenuID");
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getMenus();
  }, [location]);

  return (
    <div className="wrapper">
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <main className="content">
          <div className="row">
            <div className="col-md-12">
              <h2>Welcome To Dashboard</h2>
              <DashboardCards />
            </div>
            <div className="col-md-4 pt-4">
              <DashboardTaskTabs />
            </div>
            <div className="col-md-8 pt-4">
              <FollowupTypeLead />
            </div>
          </div>
        </main>
        <Footer />
      </div>
      <OverlayLoader
        loading={isLoading}
        message="Loading Dashboard Data"
        submessage="This might take a moment..."
      />
    </div>
  );
};

export default Dashboard;
